module.exports = __webpack_public_path__ + "img/info.ca85c853.svg";